import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const componentMapping = {
  calendarEventsListPage: defineAsyncComponent(() => importWithRetry(() => import('./calendar-events-list-page'))),
  embeddableList: defineAsyncComponent(() => importWithRetry(() => import('./embeddable-list'))),
  embeddableMapWithoutSidebar: defineAsyncComponent(() => importWithRetry(() => import('./embeddable-map-without-sidebar'))),
  embeddableMapWithSidebar: defineAsyncComponent(() => importWithRetry(() => import('./embeddable-map-with-sidebar'))),
  eventsListPage: defineAsyncComponent(() => importWithRetry(() => import('./events-list-page'))),
  localMapWithListPage: defineAsyncComponent(() => importWithRetry(() => import('./local-map-with-list-page'))),
  partnershipEventsList: defineAsyncComponent(() => importWithRetry(() => import('./partnership-events-list')))
}

addComponentLoader(componentMapping, {}, () => importWithRetry(() => import('./store')))
